define('components/charts/loaders/columns_chart',['google_charts!corechart'], function() {
    return function(chartContainer) {
        // 1. Arrange data into a Dataview with specific columns.
        // NOTE: `datatable` is retained for additional data such as a row's url (see usage of `URL_COLUMN`).
        var datatable = new google.visualization.arrayToDataTable(chartContainer.data('json'));
        var dataview = new google.visualization.DataView(datatable);
        var URL_COLUMN = 3;
        dataview.setColumns([0, 1, 2]);

        // 2. Instantiate the chart and register event listeners.
        var chart = new google.visualization.ColumnChart(chartContainer[0]);
        google.visualization.events.addListener(chart, 'select', function(e) {
            window.location = datatable.getValue(chart.getSelection()[0].row, URL_COLUMN);
        });

        // 3. Configure the chart to only draw the specific columns in `dataview`.
        var chartOptions = chartContainer.data('options');

        return {
            instance: chart,
            shouldRedrawOnWindowResize: true,
            draw: function() {
                chart.draw(dataview, chartOptions);
            },
            redraw: function() {
                chart.draw(dataview, chartOptions);
            }
        };
    };
});

